import React, { ReactNode, useState } from "react";

interface AccordionProps {
    title: string;
    icon?: ReactNode | any;
    children: ReactNode;
    isOpen?: boolean;
}


export default function Accordion({ title, icon, children, isOpen = false }: AccordionProps) {

    return (
        <div className="holidayDetail w-100">
            <div className="accordion">
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <div
                            className="title pr w-100"
                            style={{ cursor: "pointer" }}
                        >
                            <img src={icon} alt={title} width={30} height={30} />
                            <button
                                className={`btn acc-button w-100 ${!isOpen ? 'collapsed' : ''}`}
                                style={{ fontSize: '16px', fontWeight: '500' }}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#roomCancellationPolicy${title.replace(/ /g, '_')}`}
                                aria-expanded={isOpen}
                                aria-controls={`roomCancellationPolicy${title.replace(/ /g, '_')}`}
                            >
                                <div className="d-flex w-100 justify-content-between">
                                    <h4>{title}</h4>
                                    <i className="fa-solid fa-chevron-down"></i>
                                </div>
                            </button>

                        </div>
                    </h2>
                    <div id={`roomCancellationPolicy${title.replace(/ /g, '_')}`} className={`accordion-collapse collapse  ${isOpen ? "show" : ""}`}>
                        <div className="accordion-body acc-body ">
                            <div className="content">
                                {children}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
